import useFileUpload from "../components/common/fileUpload/fileUploadWithText/hooks/useFileUpload";
import {useEffect} from "react";
import {v4 as uuidv4} from "uuid";
import {FileVO} from "../types/common/basic";

interface FileHandlerProps<T extends FileVO> {
    setter: React.Dispatch<React.SetStateAction<T>>;
}

export default function useFileHandler<T extends FileVO>({setter}:FileHandlerProps<T>){
    const {files, UploadUI, handleButtonClick} = useFileUpload({
        uploadedFiles: [],
    });

    const removeFile = (fileKey: string) => {
        setter((prev) => {

            const includeFileList = (prev.fileList??[]).filter(
                (item) => item.fileKey === fileKey
            );
            if (includeFileList.length > 0) {
                // 삭제할 파일이 새로 저장할 파일일 경우
                return {
                    ...prev,
                    fileVOList: (prev?.fileVOList ?? []).filter(
                        (item) => item.fileKey !== fileKey
                    ),
                    fileList: (prev?.fileList ?? []).filter(
                        (item) => item.fileKey !== fileKey
                    ),
                };
            } else {
                // 삭제할 파일이 기존에 저장된 파일일 경우
                return {
                    ...prev,
                    fileKeyList: [...(prev.fileKeyList ?? []), fileKey],
                    fileVOList: (prev?.fileVOList ?? []).filter(
                        (item) => item.fileKey !== fileKey
                    ),
                    fileList: (prev?.fileList ?? []).filter(
                        (item) => item.fileKey !== fileKey
                    ),
                };
            }
        });
    };

    useEffect(() => {
        setter((prev: any) => {
            const fileList = [
                ...files.map((item) => ({fileKey: uuidv4(), file: item})),
            ];

            return {
                ...prev,
                fileList: fileList,
                fileVOList: [
                    ...(prev?.fileVOList ?? []),
                    ...fileList.map((item) => ({
                        fileKey: item.fileKey,
                        fileOrgname: item.file.name,
                    })),
                ],
            };
        });
    }, [files]);

    return {removeFile, UploadUI, handleButtonClick}
}